var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 266,
    viewBox: "0 0 269 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.002 27.5L135.002 4.5V50L175.002 72.5V27.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.617 7.71823L136.497 48.1682L173.047 69.2682L173.157 28.8182L136.617 7.71823Z",
    stroke: "#5FBA7D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.167 33.4482L136.597 12.3782",
    stroke: "#5FBA7D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3565 49.7282C90.6665 50.1582 91.4165 50.2082 92.0365 50.1782C93.7486 50.12 95.452 49.9092 97.1266 49.5482C98.1538 49.3901 99.1337 49.0077 99.9965 48.4282C100.422 48.0609 100.768 47.6108 101.014 47.1054C101.26 46.5999 101.4 46.0497 101.427 45.4882C101.42 44.5331 101.541 43.5813 101.787 42.6582C102.11 41.8578 102.377 41.0358 102.587 40.1982C103.147 37.0082 100.947 33.4082 99.3565 35.7582C98.4465 37.1182 96.9065 37.0782 95.8365 37.4382C93.1465 38.3382 98.4265 41.8682 90.3565 45.7682C88.9865 46.4282 89.4965 48.4882 90.3565 49.7282Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3565 49.7282C92.6665 50.1582 93.4165 50.2082 94.0365 50.1782C95.7486 50.12 97.452 49.9092 99.1266 49.5482C100.154 49.3901 101.134 49.0077 101.997 48.4282C102.422 48.0609 102.768 47.6108 103.014 47.1054C103.26 46.5999 103.4 46.0497 103.427 45.4882C103.42 44.5331 103.541 43.5813 103.787 42.6582C104.11 41.8578 104.377 41.0358 104.587 40.1982C105.147 37.0082 102.947 33.4082 101.357 35.7582C100.447 37.1182 98.9065 37.0782 97.8365 37.4382C95.1465 38.3382 100.427 41.8682 92.3565 45.7682C90.9865 46.4282 91.4965 48.4882 92.3565 49.7282Z",
    fill: "#E2D4E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.497 44.5082C101.617 43.4382 101.407 43.6782 101.787 42.6582C102.11 41.8578 102.377 41.0358 102.587 40.1982C103.147 37.0082 100.947 33.4082 99.3565 35.7582C98.4465 37.1182 96.9065 37.0782 95.8365 37.4382C93.5265 38.2082 97.0865 40.9182 93.0365 44.1382",
    stroke: "#945CA2",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8766 77.2882L63.8166 78.4182L68.0766 75.9582L66.1366 74.8282L61.8766 77.2882Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3565 76.8782L59.3665 101.768L63.8365 103.308L63.8166 78.4182L59.3565 76.8782Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8166 78.4182L63.8365 103.308L68.0865 100.848L68.0765 75.9582L63.8166 78.4182Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1966 47.3682L40.7066 43.5882L76.9966 22.6382L83.4866 26.4082L47.1966 47.3682Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3266 93.8882L40.8466 90.1182L40.7066 43.7582L47.1966 47.5282L47.3266 93.8882Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0666 26.6182L83.1965 72.9782L46.9066 93.9382L46.7765 47.5782L83.0666 26.6182Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.497 25.8882C106.957 33.8882 107.927 37.8882 99.8766 34.7882C101.447 31.0782 103.877 26.9382 103.387 22.9482C103.221 22.0145 103.154 21.066 103.187 20.1182C103.357 18.3482 103.697 12.8182 105.797 14.2582C107.367 15.3482 107.817 20.7582 107.497 25.8882Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.377 51.4882C101.657 50.5782 94.5266 42.4882 95.3766 37.4382L82.2966 32.6382L77.7966 45.1682C75.2666 47.7782 82.9066 51.8582 87.0066 53.6082C88.3102 54.1612 89.7539 54.2941 91.1366 53.9882L102.377 51.4882Z",
    fill: "white",
    stroke: "#F48024",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.257 27.1882C103.686 29.1483 102.894 31.0371 101.897 32.8182C100.667 34.9982 98.6965 37.5882 96.0765 38.0682C92.9065 38.6482 89.8365 36.6582 87.1465 35.2782C87.1465 35.2782 84.6665 33.8882 82.3265 32.6382C79.9865 31.3882 83.8965 27.3082 83.8565 26.3682C83.8165 25.4282 82.4465 26.3682 81.1865 25.5582C79.9265 24.7482 80.0465 21.0582 81.0265 19.9082C81.2207 19.6552 81.4687 19.4485 81.7525 19.3032C82.0364 19.1579 82.349 19.0775 82.6678 19.0679C82.9866 19.0584 83.3035 19.1198 83.5956 19.2479C83.8877 19.3759 84.1476 19.5673 84.3565 19.8082C85.3065 20.8082 86.7865 22.8782 91.0365 20.9182C95.2865 18.9582 98.8565 15.9782 102.037 15.6382C102.468 15.5283 102.922 15.5401 103.348 15.6725C103.773 15.8049 104.153 16.0527 104.447 16.3882C104.54 16.5783 104.607 16.7801 104.647 16.9882C105.435 20.3615 105.301 23.885 104.257 27.1882V27.1882Z",
    fill: "white",
    stroke: "#F48024",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.387 106.908C106.144 107.402 106.774 108.069 107.226 108.852C107.678 109.636 107.938 110.515 107.987 111.418C107.987 113.068 106.807 113.738 105.367 112.908C104.607 112.416 103.976 111.75 103.524 110.966C103.072 110.182 102.812 109.302 102.767 108.398C102.767 106.748 103.937 106.108 105.387 106.908Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.067 108.488C103.826 108.981 104.457 109.646 104.909 110.43C105.361 111.214 105.621 112.094 105.667 112.998C105.667 114.658 104.497 115.318 103.047 114.488C102.289 113.994 101.659 113.328 101.207 112.544C100.755 111.761 100.495 110.882 100.447 109.978C100.497 108.328 101.627 107.658 103.067 108.488Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6165 132.398L84.1465 134.618L107.647 107.728L107.527 102.868L84.1465 129.398L76.6165 127.178V132.398Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.987 102.508L84.4866 129.398L76.9566 127.178L100.447 100.298L107.987 102.508Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7865 122.888V130.978C69.7865 130.978 69.9465 134.608 75.0365 135.328C80.1265 136.048 81.8766 133.748 81.8766 133.748L82.6866 129.048L69.7865 122.888Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.591 243.879C54.4378 231.809 5.66752 190.49 12.6594 151.592C19.6513 112.694 79.7576 90.9461 146.911 103.017C214.064 115.087 262.834 156.406 255.842 195.304C248.85 234.202 188.744 255.95 121.591 243.879Z",
    fill: "#F4F8FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3865 114.958C37.8265 114.128 38.9965 114.788 39.0065 116.448C38.9574 117.351 38.6953 118.229 38.2416 119.011C37.788 119.794 37.1558 120.457 36.3965 120.948C34.9565 121.788 33.7865 121.118 33.7765 119.468C33.8265 118.564 34.0889 117.685 34.5424 116.901C34.9959 116.118 35.6277 115.452 36.3865 114.958V114.958Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8766 116.538C40.3166 115.708 41.4866 116.378 41.4866 118.028C41.4396 118.929 41.1806 119.806 40.7305 120.588C40.2804 121.37 39.6521 122.035 38.8966 122.528C37.4566 123.358 36.2766 122.698 36.2766 121.038C36.3238 120.136 36.5841 119.258 37.036 118.476C37.4879 117.694 38.1186 117.03 38.8766 116.538V116.538Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6165 127.168L68.1165 130.768L33.7066 110.898L40.2066 107.298L74.6165 127.168Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6266 127.068L74.6166 131.848L68.1066 135.538L68.1166 130.768L74.6266 127.068Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1165 130.768L68.1065 135.538L33.6866 115.668L33.7066 110.898L68.1165 130.768Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.597 122.938L80.6466 137.458L43.6866 116.128L70.6366 101.608L107.597 122.938Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M136.067 134.628L134.767 139.458L83.2866 134.738L84.5766 129.908L136.067 134.628Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6765 152.318C30.1165 151.488 31.2866 152.158 31.2966 153.808C31.2461 154.711 30.9846 155.589 30.533 156.373C30.0815 157.156 29.4525 157.822 28.6966 158.318C27.2466 159.148 26.0766 158.478 26.0766 156.828C26.1223 155.924 26.3818 155.044 26.8338 154.26C27.2857 153.476 27.9173 152.811 28.6765 152.318Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1665 153.898C32.6065 153.068 33.7765 153.738 33.7765 155.388C33.732 156.29 33.474 157.168 33.0237 157.95C32.5734 158.733 31.9437 159.397 31.1866 159.888C29.7466 160.728 28.5666 160.058 28.5666 158.398C28.6138 157.496 28.8741 156.618 29.326 155.836C29.7779 155.054 30.4086 154.39 31.1665 153.898V153.898Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2166 130.978L74.0766 135.328L27.7366 149.028L23.8766 144.678L70.2166 130.978Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8766 144.668V149.848L27.7066 154.178L73.6866 140.578V135.398L27.7066 148.998L23.8766 144.668Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7366 149.028L27.7966 154.178",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0865 121.628C71.7465 123.788 75.8966 132.628 81.3766 133.418C86.8566 134.208 135.307 103.878 135.807 103.208C135.807 103.208 122.527 100.718 119.877 100.718L100.957 103.378L71.0865 121.628Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.047 82.6382C130.947 82.5182 147.377 81.9682 153.727 81.6382C160.077 81.3082 165.427 84.2482 166.427 89.3582L157.217 94.4582C157.217 94.4582 153.107 92.2182 151.737 90.4582C150.367 88.6982 125.097 93.3682 125.097 93.3682L128.047 82.6382Z",
    fill: "white",
    stroke: "#F48024",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.997 52.1082L100.447 79.3482C102.877 83.9882 106.247 87.1282 110.327 90.6582C110.791 91.0372 111.29 91.372 111.817 91.6582C112.427 92.0382 112.737 92.5382 113.437 92.6582C117.534 93.4634 121.749 93.4634 125.847 92.6582C126.627 89.8982 127.897 84.8382 128.677 82.0782C126.297 81.8582 120.677 81.0782 120.277 80.6482C119.877 80.2182 106.767 62.4782 102.377 51.4682",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.737 51.7782L103.067 79.3082C105.487 83.9482 108.857 87.0882 112.937 90.6182C113.405 90.9973 113.907 91.3321 114.437 91.6182C115.047 91.9982 115.347 92.4982 116.057 92.6182C120.154 93.4234 124.369 93.4234 128.467 92.6182C129.237 89.8582 130.467 84.7982 131.287 82.0382C128.907 81.8182 123.287 81.0382 122.897 80.6082C122.507 80.1782 109.127 62.7882 104.737 51.7782Z",
    fill: "#D9EEFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.367 54.4182L95.8365 82.1082C102.837 83.9782 106.247 87.1082 110.327 90.6482C110.867 91.1182 110.997 91.9582 111.607 92.3382C112.217 92.7182 112.527 93.2182 113.227 93.3382C117.787 94.1882 121.657 93.4582 125.847 92.6982C126.627 89.9382 127.897 84.8782 128.677 82.1182C126.297 81.8982 120.677 81.1182 120.277 80.6882C119.877 80.2582 106.767 62.5182 102.377 51.5082",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7166 55.8082C68.585 59.4661 68.585 63.3804 69.7166 67.0382C71.9966 75.3282 68.9766 83.8082 65.0566 91.1482C61.2766 98.2482 59.3866 106.688 57.9366 114.488C57.744 115.372 57.7784 116.291 58.0365 117.158C59.8665 122.948 70.4065 123.008 75.1765 123.488C89.0365 124.898 97.9966 118.428 98.4966 115.488C98.9966 112.548 97.9166 84.3682 97.9166 84.3682C98.9866 81.6782 100.617 79.1682 101.917 76.5882C103.961 74.2595 105.432 71.4851 106.213 68.4866C106.995 65.4881 107.064 62.3484 106.417 59.3182C105.757 56.3782 103.357 52.5482 101.597 50.3182C100.897 51.4482 86.0165 57.1182 77.0065 44.3182C77.1365 44.5082 71.2966 52.3182 70.8766 53.1282C70.4107 53.9852 70.0225 54.8821 69.7166 55.8082V55.8082Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1866 55.8082C71.055 59.4661 71.055 63.3804 72.1866 67.0382C74.4666 75.3282 71.4466 83.8082 67.5266 91.1482C63.7466 98.2482 61.8566 106.688 60.4066 114.488C60.214 115.372 60.2484 116.291 60.5065 117.158C62.3365 122.948 72.8865 123.008 77.6465 123.488C91.5065 124.898 100.467 118.428 100.967 115.488C101.467 112.548 100.387 84.3682 100.387 84.3682C101.457 81.6782 103.087 79.1682 104.387 76.5882C106.431 74.2595 107.902 71.4851 108.683 68.4866C109.465 65.4881 109.534 62.3484 108.887 59.3182C108.227 56.3782 105.077 51.8182 103.307 49.6082C102.617 50.7382 88.4866 57.1382 79.4766 44.3482C79.6166 44.5382 73.7766 52.3482 73.3466 53.1582C72.8867 54.0077 72.4987 54.8941 72.1866 55.8082Z",
    fill: "#D9EEFC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.407 199.938C138.407 200.708 135.837 201.638 132.247 201.548C128.657 201.458 128.247 200.368 126.837 199.218C125.309 197.963 123.359 197.34 121.387 197.478C120.274 197.649 119.139 197.376 118.227 196.718",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.827 164.428C119.167 170.428 116.827 186.008 116.827 186.008H123.757L130.337 169.408L121.827 164.428Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M117.497 187.428C117.953 188.037 118.543 188.534 119.22 188.881C119.898 189.227 120.646 189.414 121.407 189.428C123.957 189.428 124.087 187.618 123.977 187.318C123.977 187.318 129.697 190.318 132.627 191.038C134.316 191.584 135.964 192.253 137.557 193.038C138.747 193.808 140.447 197.118 139.427 197.878C138.407 198.638 135.857 199.578 132.267 199.488C128.677 199.398 128.267 198.308 126.857 197.158C125.329 195.903 123.379 195.28 121.407 195.418C120.294 195.589 119.159 195.316 118.247 194.658C115.587 191.938 117.497 187.368 117.497 187.368V187.428Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.267 198.828C134.267 199.588 131.707 200.518 128.117 200.428C124.527 200.338 124.117 199.248 122.707 198.108C121.176 196.85 119.223 196.224 117.247 196.358C116.137 196.529 115.006 196.256 114.097 195.598",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M135.267 198.828C134.267 199.588 131.707 200.518 128.117 200.428C124.527 200.338 124.117 199.248 122.707 198.108C121.176 196.85 119.223 196.224 117.247 196.358C116.137 196.529 115.006 196.256 114.097 195.598",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M115.337 198.768L118.617 209.908C118.677 211.308 119.617 212.688 121.457 213.758C123.572 214.836 125.912 215.397 128.287 215.397C130.661 215.397 133.001 214.836 135.117 213.758C136.947 212.698 137.877 211.308 140.117 203.868L143.117 192.918",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.337 198.768L118.617 209.908C118.677 211.308 119.617 212.688 121.457 213.758C123.572 214.836 125.912 215.397 128.287 215.397C130.661 215.397 133.001 214.836 135.117 213.758C136.947 212.698 137.877 211.308 140.117 203.868L143.117 192.918",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.547 207.248L128.547 215.248",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M120.747 202.108L133.077 214.438",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M129.087 200.598L138.127 209.648",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.087 200.438L139.027 205.368",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M137.257 198.828L140.517 202.088",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M123.737 200.238L136.247 212.748",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M139.497 205.268L129.407 215.358",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M141.837 197.598L124.527 214.898",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M128.997 200.588L120.527 209.058",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M124.187 200.218L120.527 203.888",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M134.947 199.618L121.287 213.278",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.807 185.768C144.667 189.148 144.687 194.638 138.867 198.018C133.047 201.398 123.587 201.398 117.727 198.018C111.867 194.638 111.837 189.148 117.657 185.768C123.477 182.388 132.947 182.388 138.807 185.768Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.127 30.8982V30.2182L194.447 32.1382V32.8182L191.127 30.8982Z",
    fill: "#FFC522"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M191.127 30.2182V30.8982L187.797 28.9782V28.2982L191.127 30.2182Z",
    fill: "#FFC522"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M190.287 32.6682V33.0082L175.287 24.3682V24.0282L190.287 32.6682Z",
    fill: "#FFC522"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M182.787 31.2782L182.797 30.5982L186.117 32.5182V33.1982L182.787 31.2782Z",
    fill: "#FFC522"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M171.377 22.2682V21.5882L174.707 23.5082V24.1882L171.377 22.2682Z",
    fill: "#FFC522"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M174.007 10.6982L174.017 10.0182L175.057 10.6182V11.2982L174.007 10.6982Z",
    fill: "#FFC522"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M190.317 21.9682V22.3082L183.657 18.4682V18.1282L190.317 21.9682Z",
    fill: "#FFC522"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M182.817 20.9182L182.827 20.2382L186.147 22.1582V22.8382L182.817 20.9182Z",
    fill: "#FFC522"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M182.827 20.2382L182.817 20.9182L179.497 18.9982V18.3182L182.827 20.2382Z",
    fill: "#FFC522"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.807 26.0982V25.4182L186.137 27.3382V28.0182L182.807 26.0982Z",
    fill: "#FFC522"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M182.807 25.4182V26.0982L179.477 24.1782V23.4982L182.807 25.4182Z",
    fill: "#FFC522"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M182.847 10.5582L182.857 9.87824L186.177 11.7982V12.4782L182.847 10.5582Z",
    fill: "#FFC522"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M182.857 9.87822L182.847 10.5582L179.527 8.63822V7.95822L182.857 9.87822Z",
    fill: "#FFC522"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M182.837 15.0582V15.7382L175.557 11.5082V10.8282L182.837 15.0582Z",
    fill: "#FFC522"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.867 5.37824V4.69824L186.197 6.61824L186.187 7.29824L182.867 5.37824Z",
    fill: "#FFC522"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M191.107 35.3982V36.0782L187.777 34.1582L187.787 33.4782L191.107 35.3982Z",
    fill: "#FFC522"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M190.317 22.3082V22.6482L183.657 18.8082V18.4682L190.317 22.3082Z",
    fill: "#FFC522"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M191.137 25.7182V25.0382L194.467 26.9582V27.6382L191.137 25.7182Z",
    fill: "#FFC522"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M191.137 25.0382V25.7182L187.807 23.7982L187.817 23.1182L191.137 25.0382Z",
    fill: "#FFC522"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M190.297 27.1482V27.8282L183.647 23.9882V23.3082L190.297 27.1482Z",
    fill: "#FFC522"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M190.287 32.3282V32.6682L175.287 24.0282V23.6882L190.287 32.3282Z",
    fill: "#FFC522"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M190.347 11.9482V12.2882L183.687 8.44822V8.10822L190.347 11.9482Z",
    fill: "#FFC522"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M190.327 16.7882V17.4682L187.437 15.8182V15.1382L190.327 16.7882Z",
    fill: "#FFC522"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M198.667 16.4082L198.657 16.7482L192.007 12.9082V12.5682L198.667 16.4082Z",
    fill: "#FFC522"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M199.497 14.9782L199.507 14.2982L202.827 16.2182V16.8982L199.497 14.9782Z",
    fill: "#FFC522"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M199.507 14.2982L199.497 14.9782L196.177 13.0582V12.3782L199.507 14.2982Z",
    fill: "#FFC522"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M198.657 16.7482V17.0882L192.007 13.2482V12.9082L198.657 16.7482Z",
    fill: "#FFC522"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M191.167 15.3582V14.6782L194.497 16.5982V17.2782L191.167 15.3582Z",
    fill: "#FFC522"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M191.167 14.6782V15.3582L187.837 13.4382V12.7582L191.167 14.6782Z",
    fill: "#FFC522"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M182.837 15.7382V15.0582L186.167 16.9782V17.6582L182.837 15.7382Z",
    fill: "#FFC522"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M206.977 21.2082V21.5482L200.327 17.7082V17.3682L206.977 21.2082Z",
    fill: "#FFC522"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M206.977 21.5482V21.8882L200.327 18.0482V17.7082L206.977 21.5482Z",
    fill: "#FFC522"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M199.487 20.1582V19.4782L202.817 21.3982L202.807 22.0782L199.487 20.1582Z",
    fill: "#FFC522"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M199.487 19.4782V20.1582L196.157 18.2382V17.5582L199.487 19.4782Z",
    fill: "#FFC522"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M198.647 21.5882V22.2682L191.997 18.4282V17.7482L198.647 21.5882Z",
    fill: "#FFC522"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M191.157 20.5382V19.8582L194.477 21.7782V22.4582L191.157 20.5382Z",
    fill: "#FFC522"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M191.157 19.8582V20.5382L187.827 18.6182V17.9382L191.157 19.8582Z",
    fill: "#FFC522"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M190.347 11.6082V11.9482L183.687 8.10822V7.76822L190.347 11.6082Z",
    fill: "#FFC522"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M191.187 10.1782V9.49823L194.507 11.4182V12.0982L191.187 10.1782Z",
    fill: "#FFC522"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.187 9.49822V10.1782L187.857 8.25822V7.57822L191.187 9.49822Z",
    fill: "#FFC522"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.107 36.0782V35.3982L194.437 37.3282V37.9982L191.107 36.0782Z",
    fill: "#FFC522"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M199.437 35.6982L199.447 35.0182L202.767 36.9482V37.6282L199.437 35.6982Z",
    fill: "#FFC522"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M199.447 35.0182L199.437 35.6982L196.117 33.7782V33.0982L199.447 35.0182Z",
    fill: "#FFC522"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 37.1282V37.4782L191.947 33.6282V33.2882L198.607 37.1282Z",
    fill: "#FFC522"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M198.607 37.4782L198.597 37.8082L191.947 33.9682V33.6282L198.607 37.4782Z",
    fill: "#FFC522"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M206.917 41.9382V42.2782L200.267 38.4382V38.0982L206.917 41.9382Z",
    fill: "#FFC522"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M209.977 41.1082V41.7882L207.757 40.5082V39.8282L209.977 41.1082Z",
    fill: "#FFC522"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M207.757 39.8282V40.5082L204.437 38.5882V37.9082L207.757 39.8282Z",
    fill: "#FFC522"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M206.917 42.2782V42.6182L200.267 38.7682V38.4382L206.917 42.2782Z",
    fill: "#FFC522"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M199.427 40.8782V40.2082L202.757 42.1282V42.8082L199.427 40.8782Z",
    fill: "#FFC522"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M199.427 40.2082V40.8782L196.097 38.9582V38.2782L199.427 40.2082Z",
    fill: "#FFC522"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M199.477 24.6582L199.467 25.3382L196.147 23.4182V22.7382L199.477 24.6582Z",
    fill: "#FFC522"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M198.637 26.7682L198.627 27.1082L191.977 23.2682V22.9282L198.637 26.7682Z",
    fill: "#FFC522"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M198.627 27.1082V27.4482L191.977 23.6082V23.2682L198.627 27.1082Z",
    fill: "#FFC522"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M198.617 31.9482V32.6282L191.967 28.7882V28.1082L198.617 31.9482Z",
    fill: "#FFC522"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M207.787 29.4682V30.1382L204.457 28.2182L204.467 27.5382L207.787 29.4682Z",
    fill: "#FFC522"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M206.947 31.5782V31.9082L200.297 28.0682V27.7282L206.947 31.5782Z",
    fill: "#FFC522"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M206.947 31.9082V32.2582L200.297 28.4082V28.0682L206.947 31.9082Z",
    fill: "#FFC522"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M199.457 30.5182V29.8382L202.787 31.7682V32.4382L199.457 30.5182Z",
    fill: "#FFC522"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M199.457 29.8382V30.5182L196.127 28.5982V27.9182L199.457 29.8382Z",
    fill: "#FFC522"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M209.967 46.2882V46.9682L207.747 45.6882V45.0082L209.967 46.2882Z",
    fill: "#FFC522"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M207.747 45.0082V45.6882L204.417 43.7682V43.0882L207.747 45.0082Z",
    fill: "#FFC522"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M206.937 36.7582V37.4382L200.277 33.5882V32.9082L206.937 36.7582Z",
    fill: "#FFC522"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M209.997 35.9282L209.987 36.6082L207.777 35.3282V34.6482L209.997 35.9282Z",
    fill: "#FFC522"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M207.777 34.6482V35.3282L204.447 33.3982V32.7282L207.777 34.6482Z",
    fill: "#FFC522"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M210.027 25.5582L210.017 26.2382L207.807 24.9582V24.2882L210.027 25.5582Z",
    fill: "#FFC522"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M199.467 25.3382L199.477 24.6582L202.797 26.5782V27.2582L199.467 25.3382Z",
    fill: "#FFC522"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M207.807 24.2882V24.9582L204.477 23.0382V22.3582L207.807 24.2882Z",
    fill: "#FFC522"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M206.967 26.3982V27.0682L200.307 23.2282V22.5482L206.967 26.3982Z",
    fill: "#FFC522"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M207.817 19.7782V19.0982L210.037 20.3782V21.0582L207.817 19.7782Z",
    fill: "#FFC522"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M207.817 19.0982V19.7782L204.487 17.8582L204.497 17.1782L207.817 19.0982Z",
    fill: "#FFC522"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M209.977 43.6982L209.967 44.0382L208.587 43.2382V42.8982L209.977 43.6982Z",
    fill: "#FFC522"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M209.967 44.3782L208.587 43.5782V43.2382L209.967 44.0382V44.3782Z",
    fill: "#FFC522"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M209.997 33.3382V33.6782L208.617 32.8782V32.5382L209.997 33.3382Z",
    fill: "#FFC522"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M209.997 33.6782V34.0182L208.617 33.2082V32.8782L209.997 33.6782Z",
    fill: "#FFC522"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M209.987 38.5182V39.1982L208.597 38.3982V37.7182L209.987 38.5182Z",
    fill: "#FFC522"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M208.647 22.1682L210.027 22.9682V23.3082L208.647 22.5082V22.1682Z",
    fill: "#FFC522"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M210.027 23.3082V23.6482L208.647 22.8482V22.5082L210.027 23.3082Z",
    fill: "#FFC522"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M210.017 28.1582V28.8382L208.627 28.0282V27.3582L210.017 28.1582Z",
    fill: "#FFC522"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M210.007 30.7482V31.4182L207.787 30.1382V29.4682L210.007 30.7482Z",
    fill: "#FFC522"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M248.207 171.738L235.717 178.988L169.727 140.888L182.207 133.638L248.207 171.738Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M248.207 171.738L248.187 176.778L235.707 184.028L235.717 178.988L248.207 171.738Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M235.717 178.988L235.707 184.028L169.707 145.928L169.727 140.888L235.717 178.988Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M139.117 231.998L126.637 239.258L60.6366 201.148L73.1166 193.898L139.117 231.998Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M139.117 231.998L139.107 237.038L126.617 244.288L126.637 239.258L139.117 231.998Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M126.637 239.258L126.617 244.288L60.6266 206.188L60.6366 201.148L126.637 239.258Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M132.797 142.288C133.554 142.782 134.184 143.448 134.636 144.232C135.088 145.016 135.348 145.895 135.397 146.798C135.397 148.448 134.217 149.118 132.777 148.288C132.017 147.796 131.386 147.13 130.934 146.346C130.482 145.562 130.222 144.682 130.177 143.778C130.177 142.108 131.347 141.448 132.797 142.288Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M130.497 143.868C131.256 144.361 131.887 145.026 132.339 145.81C132.791 146.594 133.051 147.474 133.097 148.378C133.097 150.028 131.927 150.698 130.477 149.868C129.719 149.374 129.089 148.708 128.637 147.924C128.185 147.141 127.925 146.262 127.877 145.358C127.867 143.698 129.037 143.028 130.497 143.868Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4765 139.948L133.917 144.668L135.217 139.848V134.628L133.917 139.458L82.4765 134.738V139.948Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0866 168.478C86.5266 167.648 87.7066 168.308 87.7066 169.968C87.6593 170.87 87.3991 171.748 86.9471 172.531C86.4952 173.313 85.8645 173.977 85.1066 174.468C83.6666 175.308 82.4866 174.638 82.4866 172.988C82.5323 172.084 82.7918 171.204 83.2438 170.42C83.6958 169.636 84.3273 168.971 85.0866 168.478V168.478Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5766 170.108C89.0166 169.278 90.1865 169.948 90.1965 171.598C90.1477 172.5 89.8868 173.377 89.435 174.159C88.9832 174.941 88.3534 175.606 87.5966 176.098C86.1566 176.928 84.9765 176.268 84.9765 174.608C85.0254 173.707 85.2863 172.829 85.7381 172.047C86.1899 171.265 86.8197 170.601 87.5766 170.108V170.108Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1865 140.958L82.4765 170.678L90.7865 169.918V164.708L82.4765 165.478L74.1865 135.758V140.958Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4866 165.508V170.388",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4866 134.938L90.8065 164.748L82.4765 165.508L74.1566 135.708L82.4866 134.938Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M134.247 139.638V144.518",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M108.147 128.868L81.0666 143.398L43.6865 121.818V116.178L81.0666 137.758L108.147 123.228V128.868Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5265 143.548V139.638",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M123.497 95.6882V90.8082",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M116.667 191.888H119.597V195.798H116.667V191.888Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M140.727 170.408L139.977 174.468C140.433 175.077 141.023 175.574 141.7 175.921C142.378 176.267 143.126 176.454 143.887 176.468C146.437 176.468 146.537 175.018 146.437 174.718L144.437 170.388L140.727 170.408Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M144.127 149.808C141.467 155.808 139.127 171.378 139.127 171.378H146.057L152.647 154.788L144.127 149.808Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M139.977 174.178C140.433 174.787 141.023 175.284 141.7 175.631C142.378 175.977 143.126 176.164 143.887 176.178C146.437 176.178 146.567 174.378 146.457 174.068C146.457 174.068 152.177 177.068 155.117 177.788C156.803 178.335 158.447 179.003 160.037 179.788C161.227 180.558 162.927 183.868 161.907 184.628C160.887 185.388 158.337 186.328 154.747 186.238C151.157 186.148 150.747 185.058 149.337 183.908C147.809 182.653 145.859 182.03 143.887 182.168C142.774 182.339 141.639 182.066 140.727 181.408C138.067 178.688 139.977 174.118 139.977 174.118V174.178Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M118.617 160.148V229.258L108.847 223.548V158.198",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M118.617 160.148V229.258L108.847 223.548V158.198",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M118.617 229.258L121.547 227.728V172.188L118.617 170.348V229.258Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M229.957 100.578V169.928L220.187 164.218V99.5982",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M229.957 100.578V169.928L220.187 164.218V99.5982",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M229.957 169.928L232.887 168.438V114.528L229.957 112.748V169.928Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M114.897 115.158C110.109 113.73 105.231 112.621 100.297 111.838Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M114.897 115.158C110.109 113.73 105.231 112.621 100.297 111.838",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M254.397 105.438L137.547 173.338L74.6665 137.038L191.517 69.1282L254.397 105.438Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M153.247 146.558L129.667 160.258L89.7966 137.238L113.377 123.538L153.247 146.558Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M133.777 138.568C133.858 138.598 133.928 138.651 133.978 138.722C134.027 138.793 134.054 138.877 134.054 138.963C134.054 139.05 134.027 139.134 133.978 139.205C133.928 139.275 133.858 139.329 133.777 139.358L118.887 148.008C118.676 148.117 118.443 148.174 118.207 148.174C117.97 148.174 117.737 148.117 117.527 148.008L116.157 147.228C116.076 147.197 116.007 147.141 115.959 147.07C115.91 146.999 115.884 146.915 115.884 146.828C115.884 146.742 115.91 146.658 115.959 146.586C116.007 146.515 116.076 146.46 116.157 146.428L131.047 137.778C131.259 137.673 131.494 137.617 131.732 137.617C131.969 137.617 132.204 137.673 132.417 137.778L133.777 138.568Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M141.497 143.108C141.578 143.138 141.648 143.191 141.698 143.262C141.747 143.333 141.774 143.417 141.774 143.503C141.774 143.59 141.747 143.674 141.698 143.745C141.648 143.815 141.578 143.869 141.497 143.898L134.737 147.828C134.525 147.937 134.29 147.994 134.052 147.994C133.813 147.994 133.578 147.937 133.367 147.828L132.007 147.048C131.925 147.019 131.855 146.965 131.806 146.895C131.756 146.824 131.729 146.74 131.729 146.653C131.729 146.567 131.756 146.483 131.806 146.412C131.855 146.341 131.925 146.288 132.007 146.258L138.767 142.318C138.978 142.209 139.213 142.153 139.452 142.153C139.69 142.153 139.925 142.209 140.137 142.318L141.497 143.108Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M127.187 134.588C127.567 134.808 127.567 135.158 127.187 135.368L112.297 144.028C112.085 144.137 111.85 144.194 111.612 144.194C111.373 144.194 111.138 144.137 110.927 144.028L109.567 143.238C109.197 143.028 109.197 142.668 109.567 142.448L124.497 133.798C124.705 133.694 124.934 133.64 125.167 133.64C125.399 133.64 125.628 133.694 125.837 133.798L127.187 134.588Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M120.257 130.278C120.637 130.498 120.627 130.848 120.257 131.068L105.367 139.718C105.156 139.825 104.923 139.88 104.687 139.88C104.45 139.88 104.217 139.825 104.007 139.718L102.637 138.928C102.554 138.902 102.482 138.849 102.431 138.779C102.38 138.709 102.353 138.625 102.353 138.538C102.353 138.452 102.38 138.367 102.431 138.297C102.482 138.227 102.554 138.175 102.637 138.148L117.497 129.488C117.707 129.382 117.94 129.326 118.177 129.326C118.413 129.326 118.646 129.382 118.857 129.488L120.257 130.278Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M129.947 149.518C131.637 150.518 131.647 152.088 129.947 153.068C128.997 153.547 127.949 153.796 126.887 153.796C125.824 153.796 124.776 153.547 123.827 153.068C122.127 152.068 122.117 150.488 123.827 149.518C124.775 149.038 125.823 148.788 126.887 148.788C127.95 148.788 128.998 149.038 129.947 149.518V149.518Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M199.987 100.158L148.987 129.778L118.387 112.108V107.618L148.987 125.278L199.987 96.0382V100.158Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M199.247 95.8382L148.987 125.048L118.387 107.378L168.647 78.1682L199.247 95.8382Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M149.187 125.448V129.828",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M254.397 105.458L137.547 173.458L74.6665 137.088L74.6965 144.748L137.697 181.918L254.367 114.048L254.397 105.458Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M111.447 102.878C118.257 101.758 134.317 96.4082 136.057 96.5282C137.797 96.6482 140.287 99.2682 143.157 99.7082C146.027 100.148 148.257 96.5282 148.257 96.5282C149.298 98.0724 150.462 99.5305 151.737 100.888C152.617 101.508 153.607 99.3882 153.237 98.7682C152.867 98.1482 150.497 90.4282 147.007 89.1082C143.512 87.6344 139.655 87.2442 135.937 87.9882C132.447 88.8582 114.697 91.3482 114.697 91.3482L111.447 102.878Z",
    fill: "white",
    stroke: "#F48024",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M199.887 59.7282L199.987 96.1282L149.057 125.528L148.957 89.1282L199.887 59.7282Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M161.907 187.558C160.907 188.318 158.337 189.258 154.747 189.168C151.157 189.078 150.747 187.988 149.337 186.838C147.809 185.583 145.859 184.96 143.887 185.098C142.773 185.27 141.637 184.993 140.727 184.328",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7166 55.8082C68.585 59.4661 68.585 63.3804 69.7166 67.0382C71.9966 75.3282 68.9766 83.8082 65.0566 91.1482C61.2766 98.2482 59.3866 106.688 57.9366 114.488C57.744 115.372 57.7784 116.291 58.0365 117.158C59.8665 122.948 70.4065 123.008 75.1765 123.488C89.0365 124.898 97.9966 118.428 98.4966 115.488C98.9966 112.548 97.9166 84.3682 97.9166 84.3682C98.9866 81.6782 100.617 79.1682 101.917 76.5882C103.961 74.2595 105.432 71.4851 106.213 68.4866C106.995 65.4881 107.064 62.3484 106.417 59.3182C105.757 56.3782 103.357 52.5482 101.597 50.3182C100.897 51.4482 86.0165 57.1182 77.0065 44.3182C77.1365 44.5082 71.2966 52.3182 70.8766 53.1282C70.4107 53.9852 70.0225 54.8821 69.7166 55.8082V55.8082Z",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M137.547 173.338V180.958",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9866 61.3882C74.4866 64.1282 90.3666 98.2982 94.7666 100.618C99.7937 103.406 105.613 104.42 111.287 103.498L114.697 90.5582C114.697 90.5582 106.697 90.7182 105.097 89.5582C103.497 88.3982 100.817 82.3782 99.5565 80.3882C98.2965 78.3982 90.4965 63.5182 90.4965 63.5182C90.4965 63.5182 83.1966 48.1882 75.8166 51.1082C68.4366 54.0282 72.9866 61.3882 72.9866 61.3882Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9866 61.3882C77.4866 64.1282 93.3666 98.2982 97.7666 100.618C102.794 103.406 108.613 104.42 114.287 103.498L117.697 90.5582C117.697 90.5582 109.697 90.7182 108.097 89.5582C106.497 88.3982 103.817 82.3782 102.557 80.3882C101.297 78.3982 93.4965 63.5182 93.4965 63.5182C93.4965 63.5182 86.1966 48.1882 78.8166 51.1082C71.4366 54.0282 75.9866 61.3882 75.9866 61.3882Z",
    fill: "#D9EEFC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9866 61.3882C78.3966 72.4482 91.5866 98.9482 94.7666 100.618C99.7937 103.406 105.613 104.42 111.287 103.498L114.697 90.5582C114.697 90.5582 106.697 90.7182 105.097 89.5582C103.497 88.3982 100.817 82.3782 99.5565 80.3882C98.2965 78.3982 90.4965 63.5182 90.4965 63.5182C90.4965 63.5182 83.1966 48.1882 75.8166 51.1082C68.4366 54.0282 72.9866 61.3982 72.9866 61.3982",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M176.461 96.6978C174.931 95.8087 174.936 92.947 176.471 90.3062C178.007 87.6654 180.491 86.2454 182.021 87.1346C183.55 88.0238 183.545 90.8854 182.01 93.5262C180.474 96.167 177.99 97.587 176.461 96.6978Z",
    fill: "#FFC522"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M173.853 97.9679C172.316 97.0744 172.32 94.1978 173.863 91.5428C175.406 88.8878 177.903 87.4598 179.44 88.3532C180.978 89.2467 180.974 92.1233 179.431 94.7783C177.888 97.4333 175.391 98.8613 173.853 97.9679Z",
    stroke: "#F48024",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M145.927 39.0882L145.917 39.9082L143.057 38.2482V37.4382L145.927 39.0882Z",
    fill: "#5FBA7D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M161.117 44.9882C160.927 44.8682 160.767 44.9882 160.767 45.1882V48.7382C160.772 48.8604 160.807 48.9795 160.868 49.0855C160.929 49.1916 161.014 49.2817 161.117 49.3482L164.197 51.1082C164.387 51.2282 164.547 51.1082 164.547 50.9082V47.3882C164.545 47.2638 164.512 47.1418 164.451 47.0334C164.39 46.925 164.302 46.8338 164.197 46.7682L161.117 44.9882ZM163.847 50.1082L161.497 48.7282V46.0082L163.877 47.3782V50.1082",
    fill: "#5FBA7D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M154.167 51.2482V52.0582L151.307 50.4082V49.5882L154.167 51.2482Z",
    fill: "#5FBA7D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M150.007 48.8482V49.6582L147.137 48.0082V47.1882L150.007 48.8482Z",
    fill: "#5FBA7D"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M166.427 55.4382C166.227 55.3282 166.077 55.4382 166.077 55.6482V59.1882C166.082 59.312 166.116 59.4327 166.177 59.5405C166.238 59.6483 166.323 59.7401 166.427 59.8082L169.497 61.5882C169.697 61.6982 169.857 61.5882 169.857 61.3782V57.8382C169.85 57.7138 169.814 57.5928 169.751 57.4851C169.688 57.3773 169.601 57.2859 169.497 57.2182L166.427 55.4382ZM169.147 60.5682L166.777 59.1982V56.4582L169.157 57.8382V60.5682",
    fill: "#BBC0C4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M155.777 49.2882C155.577 49.1782 155.417 49.2882 155.417 49.4982V53.0382C155.423 53.1628 155.458 53.2842 155.521 53.392C155.584 53.4999 155.671 53.5912 155.777 53.6582L158.857 55.4382C159.057 55.5482 159.217 55.4382 159.217 55.2382V51.6882C159.209 51.5654 159.172 51.446 159.11 51.34C159.047 51.234 158.96 51.1443 158.857 51.0782L155.777 49.2882ZM158.497 54.4182L156.127 53.0482V50.3082L158.497 51.6782V54.4182Z",
    fill: "#BBC0C4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M154.177 49.0682V49.8882L140.107 41.7682V40.9482L154.177 49.0682Z",
    fill: "#5FBA7D"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M154.187 43.8682V44.6782L151.327 43.0282V42.2082L154.187 43.8682Z",
    fill: "#5FBA7D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M150.067 28.1382V28.9582L147.197 27.2982V26.4882L150.067 28.1382Z",
    fill: "#5FBA7D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M145.907 46.4782L145.897 47.2882L143.037 45.6282V44.8182L145.907 46.4782Z",
    fill: "#5FBA7D"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M150.027 41.4582V42.2782L147.157 40.6282L147.167 39.8082L150.027 41.4582Z",
    fill: "#5FBA7D"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M145.947 32.4582L145.937 33.2682L143.077 31.6182V30.7982L145.947 32.4582Z",
    fill: "#5FBA7D"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M150.047 34.8282V35.6382L147.177 33.9882L147.187 33.1682L150.047 34.8282Z",
    fill: "#5FBA7D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M154.197 41.6882V42.4982L140.127 34.3782L140.137 33.5682L154.197 41.6882Z",
    fill: "#5FBA7D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M145.967 25.7682L145.957 26.5882L143.097 24.9282V24.1182L145.967 25.7682Z",
    fill: "#5FBA7D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M154.217 35.0582V35.8682L140.147 27.7482L140.157 26.9382L154.217 35.0582Z",
    fill: "#5FBA7D"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M154.227 30.5482V31.3582L151.357 29.6982L151.367 28.8882L154.227 30.5482Z",
    fill: "#5FBA7D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M154.237 28.3682V29.1882L140.167 21.0682V20.2482L154.237 28.3682Z",
    fill: "#5FBA7D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M166.497 34.7382C166.297 34.6282 166.147 34.7382 166.137 34.9482V38.4882C166.145 38.6123 166.182 38.7327 166.244 38.8402C166.307 38.9477 166.393 39.0394 166.497 39.1082L169.587 40.8882C169.787 40.9982 169.947 40.8882 169.947 40.6782V37.1082C169.94 36.9836 169.905 36.8623 169.842 36.7544C169.779 36.6465 169.692 36.5553 169.587 36.4882L166.497 34.7382ZM169.217 39.8682L166.837 38.4982V35.7582L169.217 37.1082V39.8482",
    fill: "#BBC0C4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M161.157 31.6682C160.957 31.5482 160.797 31.6682 160.797 31.8682V35.4082C160.803 35.5328 160.838 35.6542 160.901 35.7621C160.964 35.8699 161.051 35.9612 161.157 36.0282L164.227 37.8082C164.427 37.9282 164.587 37.8082 164.587 37.6082V34.1082C164.579 33.9864 164.544 33.868 164.483 33.7621C164.422 33.6563 164.338 33.566 164.237 33.4982L161.157 31.6682ZM163.877 36.7882L161.497 35.4182V32.6782L163.887 34.1082V36.8382",
    fill: "#5FBA7D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M155.837 28.5882C155.637 28.4782 155.477 28.5882 155.477 28.7982V32.3382C155.483 32.4627 155.52 32.5837 155.582 32.6914C155.645 32.7992 155.732 32.8906 155.837 32.9582L158.917 34.7382C159.117 34.8482 159.277 34.7382 159.277 34.5282V30.9882C159.27 30.8638 159.234 30.7428 159.171 30.635C159.108 30.5273 159.021 30.4359 158.917 30.3682L155.837 28.5882ZM158.497 33.7182L156.127 32.3382V29.6082L158.497 30.9782V33.7182Z",
    fill: "#BBC0C4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M154.207 37.2282V38.0382L151.337 36.3882L151.347 35.5682L154.207 37.2282Z",
    fill: "#5FBA7D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M166.497 41.4182C166.297 41.3082 166.147 41.4182 166.147 41.6282V45.1682C166.152 45.2919 166.186 45.4127 166.247 45.5205C166.308 45.6283 166.393 45.7201 166.497 45.7882L169.497 47.5682C169.697 47.6782 169.857 47.5682 169.857 47.3582V43.8182C169.85 43.6938 169.814 43.5728 169.751 43.465C169.688 43.3573 169.601 43.2659 169.497 43.1982L166.497 41.4182ZM169.217 46.5482L166.847 45.1782V42.4382L169.197 43.8182V46.5482",
    fill: "#BBC0C4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M161.137 38.3482C160.947 38.2282 160.787 38.3482 160.777 38.5482V42.1082C160.784 42.2311 160.821 42.3504 160.883 42.4565C160.946 42.5625 161.033 42.6522 161.137 42.7182L164.217 44.4982C164.417 44.6182 164.577 44.4982 164.577 44.2982V40.7482C164.571 40.6247 164.536 40.5043 164.475 40.3966C164.415 40.2889 164.329 40.197 164.227 40.1282L161.137 38.3482ZM163.867 43.4782L161.497 42.1082V39.3682L163.877 40.7382V43.4782",
    fill: "#5FBA7D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M155.817 35.2682C155.617 35.1582 155.457 35.2682 155.457 35.4782V39.0182C155.463 39.1428 155.498 39.2642 155.561 39.372C155.624 39.4799 155.711 39.5712 155.817 39.6382L158.897 41.4182C159.097 41.5282 159.257 41.4182 159.257 41.2182V37.6682C159.242 37.5541 159.202 37.4447 159.139 37.3479C159.077 37.2511 158.994 37.1692 158.897 37.1082L155.817 35.2682ZM158.497 40.3982L156.127 39.0282V36.2882L158.497 37.6582V40.3982Z",
    fill: "#BBC0C4"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M166.447 48.1082C166.247 47.9982 166.097 48.1082 166.097 48.3182V51.8082C166.102 51.9319 166.136 52.0527 166.197 52.1605C166.258 52.2683 166.343 52.3601 166.447 52.4282L169.497 54.2082C169.697 54.3182 169.857 54.2082 169.857 53.9982V50.4582C169.85 50.3338 169.814 50.2128 169.751 50.105C169.688 49.9973 169.601 49.9059 169.497 49.8382L166.447 48.1082ZM169.167 53.2282L166.797 51.8082V49.1082L169.177 50.4782V53.2082",
    fill: "#BBC0C4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M155.797 41.9082C155.597 41.7982 155.437 41.9082 155.437 42.1182V45.6582C155.443 45.7828 155.478 45.9041 155.541 46.012C155.604 46.1199 155.691 46.2112 155.797 46.2782L158.867 48.1082C159.067 48.2182 159.227 48.1082 159.227 47.9082V44.3082C159.22 44.1838 159.184 44.0628 159.121 43.955C159.058 43.8473 158.971 43.7558 158.867 43.6882L155.797 41.9082ZM158.497 47.0282L156.117 45.6582V42.9282L158.497 44.2982V47.0282",
    fill: "#BBC0C4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M161.097 52.3682C160.907 52.2482 160.747 52.3682 160.737 52.5682V56.1082C160.744 56.2311 160.781 56.3504 160.843 56.4564C160.906 56.5625 160.993 56.6522 161.097 56.7182L164.167 58.5082C164.367 58.6282 164.527 58.5082 164.527 58.3082V54.7682C164.522 54.6443 164.488 54.5233 164.428 54.4153C164.367 54.3074 164.28 54.2158 164.177 54.1482L161.097 52.3682ZM163.827 57.4982L161.437 56.1082V53.3882L163.817 54.7582V57.4982",
    fill: "#5FBA7D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6165 105.348L68.1165 108.938L33.6965 89.0682L40.2066 85.4782L74.6165 105.348Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6266 105.248L74.6166 110.018L68.0966 113.718L68.1166 108.938L74.6266 105.248Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1165 108.938L68.0966 113.718L33.6866 93.8482L33.6965 89.0682L68.1165 108.938Z",
    fill: "white",
    stroke: "#1060E1",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6465 78.3682C99.3965 80.0882 101.317 80.0282 101.577 78.1682C102.437 71.9382 99.2565 58.1182 98.3965 52.7082C98.1769 51.0208 97.6191 49.395 96.7565 47.9282C95.8992 46.4895 94.5203 45.4365 92.9066 44.9882C92.2584 44.8242 91.5764 44.8542 90.9452 45.0747C90.314 45.2951 89.7616 45.6963 89.3566 46.2282C87.9566 48.0082 88.7165 49.9482 89.1365 51.7982C89.9865 55.5182 89.1366 59.3582 90.9066 62.7182C93.3566 67.3082 97.6765 76.1082 98.6465 78.3682Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 44.7582C104.247 45.2582 104.337 50.1882 101.747 50.9182C99.7465 51.4782 88.4865 56.7482 74.5865 45.1082C73.2665 43.9982 74.3166 42.2582 74.7366 40.8682C74.8513 40.2752 75.1115 39.7199 75.4937 39.2522C75.8759 38.7844 76.3682 38.4189 76.9265 38.1882C78.5965 37.6282 79.9265 39.1882 81.5065 39.6082C83.0865 40.0282 85.5065 42.0582 87.1765 42.7282C91.6865 44.5482 97.5665 43.3482 102.497 44.7582Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2765 39.9082C93.4865 41.4682 93.7266 42.9882 93.9866 43.9082L98.8965 44.1082",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M100.647 78.3682C101.397 80.0882 103.317 80.0282 103.577 78.1682C104.437 71.9382 101.257 58.1182 100.397 52.7082C100.177 51.0208 99.6191 49.395 98.7565 47.9282C97.8992 46.4895 96.5203 45.4365 94.9066 44.9882C94.2584 44.8242 93.5764 44.8542 92.9452 45.0747C92.314 45.2951 91.7616 45.6963 91.3566 46.2282C89.9566 48.0082 90.7165 49.9482 91.1365 51.7982C91.9865 55.5182 91.1366 59.3582 92.9066 62.7182C95.3566 67.3082 99.6765 76.1082 100.647 78.3682Z",
    fill: "#E2D4E9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M104.497 44.7582C106.247 45.2582 106.337 50.1882 103.747 50.9182C101.747 51.4782 90.4865 56.7482 76.5865 45.1082C75.2665 43.9982 76.3166 42.2582 76.7366 40.8682C76.8513 40.2752 77.1115 39.7199 77.4937 39.2522C77.8759 38.7844 78.3682 38.4189 78.9265 38.1882C80.5965 37.6282 81.9265 39.1882 83.5065 39.6082C85.0865 40.0282 87.5065 42.0582 89.1765 42.7282C93.6865 44.5482 99.5665 43.3482 104.497 44.7582Z",
    fill: "#E2D4E9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2765 39.9082C94.4865 41.4682 94.7266 42.9882 94.9866 43.9082L99.8965 44.1082",
    fill: "#E2D4E9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2765 39.9082C94.4865 41.4682 94.7266 42.9882 94.9866 43.9082L99.8965 44.1082",
    fill: "#E2D4EA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2765 39.9082C94.4865 41.4682 94.7266 42.9882 94.9866 43.9082L99.8965 44.1082",
    stroke: "#945CA2",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M102.497 44.7582C104.247 45.2582 104.337 50.1882 101.747 50.9182C99.7465 51.4782 88.4865 56.7482 74.5865 45.1082C73.2665 43.9982 74.3166 42.2582 74.7366 40.8682C74.8513 40.2752 75.1115 39.7199 75.4937 39.2521C75.8759 38.7844 76.3682 38.4188 76.9265 38.1882C78.5965 37.6282 79.9765 38.5082 81.3365 39.1882C82.9365 39.9882 85.5065 42.0482 87.1765 42.7182C91.6865 44.5482 97.5665 43.3482 102.497 44.7582Z",
    stroke: "#945CA2",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2666 52.9482C90.8266 56.3882 90.2066 59.8982 91.8566 62.9482C94.3066 67.5382 98.6366 76.3882 99.6066 78.6082C100.357 80.3282 102.277 80.2582 102.527 78.3982C103.387 72.1682 100.117 57.8282 99.2565 52.3982",
    stroke: "#945CA2",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M103.668 28.2408C102.656 27.6526 102.658 25.7589 103.674 24.0112C104.689 22.2634 106.333 21.3235 107.346 21.9117C108.358 22.5 108.356 24.3937 107.34 26.1414C106.324 27.8891 104.68 28.8291 103.668 28.2408Z",
    fill: "white",
    stroke: "#945CA2",
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0894 30.2417C95.0771 29.6535 95.0797 27.7598 96.0952 26.0121C97.1108 24.2643 98.7547 23.3244 99.7671 23.9127C100.779 24.5009 100.777 26.3946 99.7613 28.1423C98.7457 29.89 97.1017 30.83 96.0894 30.2417Z",
    fill: "white",
    stroke: "#945CA2",
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M103.447 25.2582C102.428 25.0735 101.378 25.3001 100.527 25.8882Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M103.447 25.2582C102.428 25.0735 101.378 25.3001 100.527 25.8882",
    stroke: "#945CA2",
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3365 27.0682L88.0365 24.1182",
    stroke: "#945CA2",
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9765 20.1082C96.3665 21.9982 92.2666 22.6782 88.2366 23.2682C87.9266 26.6482 86.8965 36.4782 87.0365 39.8682C81.3865 38.3627 76.0521 35.8563 71.2865 32.4682C70.3879 31.902 69.6125 31.1606 69.0065 30.2882C68.2677 28.8501 68.0352 27.2048 68.3466 25.6182C69.3466 17.2182 71.8765 3.96823 85.1765 1.42823C88.3397 0.800099 91.6014 0.863639 94.7377 1.61449C97.874 2.36534 100.811 3.78574 103.347 5.77823C105.807 7.77823 107.787 9.62823 106.717 12.8582C105.647 16.0882 102.857 18.5782 99.9765 20.1082Z",
    fill: "white",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2366 23.2582C86.1858 23.0719 84.2548 22.2102 82.7466 20.8082Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2366 23.2582C86.1858 23.0719 84.2548 22.2102 82.7466 20.8082",
    stroke: "#021766",
    strokeWidth: 1.07,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.8ccb45216052c69086cc63b67a2f37c6.svg";
export { ForwardRef as ReactComponent };